import { _label } from '../../../vernacular/AppLanguage';

export const LABELS = {
  BOOKING_DETAILS: "booking_details",
  FORGOT_IRCTC_PASSWORD: "forgot_irctc_password",
  DIFFERENT_IRCTC_USERNAME: "different_irctc_username",
  CAPTCHA: "captcha",
  CANCEL_BOOKING: "cancel_booking",
  WRONG_CREDENTIALS: "wrong_credentials",
  OTHER_ISSUES: "other_issues",
  GET_NEW_PASSWORD: "get_new_password", // { uppercase: true }),
  GET_NEW_USERNAME: "get_new_username", // { uppercase: true }),
  NEED_HELP: "need_help",
  CAPTCHA_LINE_1: "captcha_line_1",
  CAPTCHA_LINE_2: "captcha_line_2",
  CAPTCHA_LINE_3: "captcha_line_3",
  CONTINUE_BOOKING: "continue_booking",
  API_FAILURE_MESSAGE: "api_failure_message",
  FEEDBACK_PLACEHOLDER: "feedback_placeholder",
};
